(function () {
  // The header's language <select> shows full names ("English", "العربية") by default.
  // The header always uses the hamburger layout (desktop included — see header.liquid),
  // so there's never a wide inline-nav context where the full word is needed; always
  // show the compact label. The value attribute (what actually drives the language
  // switch) is untouched — this only changes what's displayed.
  var LABELS = { en: 'EN', ar: 'ع' };

  function compact() {
    var select = document.getElementById('dropdownSelect');
    if (!select) return;
    Array.prototype.forEach.call(select.options, function (option) {
      var short = LABELS[option.value];
      if (short) option.textContent = short;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compact);
  } else {
    compact();
  }
})();
